import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'

import { SettingsIcon } from '@/modules/shared/icons/SettingsIcon'

interface UtilitiesSideBarItemProps {
  onCloseDrawer: () => void
}

export const UtilitiesSideBarItem = ({ onCloseDrawer }: UtilitiesSideBarItemProps) => {
  const { t } = useTranslation()

  return (
    <NavLink
      data-testid="utilities-navigation-link"
      to="/utilities"
      onClick={() => onCloseDrawer()}
      className="flex h-11 w-full items-center gap-x-2 rounded-md bg-gray-200 px-3"
    >
      <SettingsIcon className="size-7" />
      {t('general.utilities', 'Utilities')}
    </NavLink>
  )
}
